      <div class="main">
        <div class="mainSection">
          <div class="header">
            <div class="title">
              <div class="label">
                {{'OPEN_BID.openbids' | translate}}
              </div>
              <div class="help">
                <!-- <app-help [helpData]="helpData" ></app-help> -->
              </div>
            </div>
            <div class="refresh" (click)="paginator.pageIndex = 0;getOrders()"><i class="material-icons" >refresh</i></div>
          </div>
          <div class="orders">
            <div class="load">

              <ng-container *ngIf="isMobileView">
                <ng-container *ngIf="ordersList && ordersList.filteredData.length; else noOrders">
                  <div class="mobile-card" *ngFor="let element of ordersList?.filteredData;">
                    <div class="card-header">
                        <b>{{ element.order }}</b>
                        <img *ngIf="element.is_bidding" src="assets/Bid-Icon.svg" class="bidHammerImg" alt="">
                    </div>
  
                    <div class="card-content">
                      <div class="row" style="gap: 25px;"><b style="color: rgba(0,0,0,.54);">{{'OPEN_BID.shipper' | translate}}: </b> <span style="font-weight: bolder;">{{ element.shipper.parent_name }} - {{ element.shipper.name }}</span></div>
                
                      <div class="row">
                        <b style="color: rgba(0,0,0,.54);">{{'OPEN_BID.from' | translate}}: </b>
                        <ng-container *ngFor="let pick of element.from; let i = index">
                          <div style="margin-left: 6px;">
                            <strong style="color: #0B7D2E;">P{{ i + 1 }}</strong> - <span style="font-weight: bolder;">{{ pick.loc_id.name }}, {{ pick.loc_id.city }}</span>
                          </div>
                        </ng-container>
                      </div>
                  
                      <div class="row">
                        <b style="color: rgba(0,0,0,.54);">To: </b>
                        <ng-container *ngFor="let drop of element.to; let i = index">
                          <div style="margin-left: 6px;">
                            <b style="color: #D8511F;">D{{ i + 1 }}</b> - <span style="font-weight: bolder;">{{ drop.loc_id.name }}, {{ drop.loc_id.city }}</span>
                          </div>
                        </ng-container>
                      </div>
                  
                      <div class="row">
                        <b style="color: rgba(0,0,0,.54);">{{'OPEN_BID.vehType' | translate}}: </b> 
                        <span style="font-weight: bolder;">{{ element.vehicle?.name || element.vehicle }}</span>
                      </div>
                  
                      <div class="row">
                        <b style="color: rgba(0,0,0,.54);">{{'OPEN_BID.requested' | translate}}</b>
                        <ng-container *ngIf="!element.weight_based">
                          <span style="font-weight: bolder;">
                            <b style="color: rgba(0,0,0,.54);">{{'BIDORDER.no_of_vehicles' | translate}}:</b> 
                            {{ element.req_no_of_vehicles }}
                          </span>
                          <span *ngIf="element.cancelled_vehicles" style="color:red;">
                            {{'BIDORDER.cancelled' | translate}}: {{ element.cancelled_vehicles }}
                          </span>
                        </ng-container>
                        <ng-container *ngIf="element.weight_based">
                          <span style="font-weight: bolder;">
                            <b style="color: rgba(0,0,0,.54);">{{'BIDORDER.weight_requested' | translate}}:</b> 
                            {{ element.shipmentWeight }} {{ element.uom | titlecase }}
                          </span>
                        </ng-container>
                      </div>
                  
                      <div class="row"><b style="color: rgba(0,0,0,.54);">{{'OPEN_BID.bidEndTime' | translate}}: </b> <span style="font-weight: bolder;">{{ element.deadline }}</span></div>
                  
                      <div class="row">
                        <b style="color: rgba(0,0,0,.54);">{{'OPEN_BID.startingBidAmount' | translate}} ({{currencySymbol}}) : </b>
                        <ng-container *ngIf="element.bid_flow !== 'rfq'">
                          <span style="font-weight: bolder;">{{ element.costPerVehicle | numberFormat: element.costPerVehicle }}</span>
                          <span *ngIf="element.weight_based" style="font-weight: bolder;">/ {{ element.uom | titlecase }}</span>
                        </ng-container>
                        <ng-container *ngIf="element.bid_flow === 'rfq'" style="font-weight: bolder;"> - </ng-container>
                      </div>
                    </div>
                
                    <div class="card-button" (click)="openBidAcceptDialog(element)">
                      {{ 'OPEN_BID.startBid' | translate }}
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              

              <ng-container *ngIf="!isMobileView">
              <table mat-table *ngIf="ordersList && ordersList.filteredData.length;else noOrders" [dataSource]="ordersList" matSort (matSortChange)="sortOrderData($event)" class="orderTable">
                <ng-container matColumnDef="order">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
                    <!-- Order  -->
                    <input type="text" [placeholder]="'OPEN_BID.order' | translate" title="Order" [(ngModel)]="filterOrder" (keyup)="searchFilter(filterOrder, 'order')" (click)="$event.stopPropagation()" class="formField" />

                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.order}}
                    <div class="bidIcon">
                      <img *ngIf="element.is_bidding" src="assets/Bid-Icon.svg" class="bidHammerImg" alt="">
                    </div>
                  </td>
                </ng-container>

                <!-- <ng-container matColumnDef="organization">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
                    Organization
                    <input type="text" placeholder="Organization" title="Organization" (click)="$event.stopPropagation()" class="formField" />
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.organization.name}} </td>
                </ng-container> -->

                <ng-container matColumnDef="shipper">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
                    <!-- Shipper -->
                    <input type="text" [placeholder]="'OPEN_BID.shipper' | translate" [(ngModel)]="filterShipper" title="Shipper" (keyup)="searchFilter(filterShipper, 'shipper')" (click)="$event.stopPropagation()" class="formField" />
                  </th>
                  <td mat-cell *matCellDef="let element"> 
                  <span style="font-weight: bold;">{{element.shipper.parent_name}} - </span>  {{element.shipper.name}} 
                  </td>
                </ng-container>



                <ng-container matColumnDef="from">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader" style="text-align: center;">
                    {{'OPEN_BID.from' | translate}}
                    <!-- <input type="text" placeholder="From" title="From" (click)="$event.stopPropagation()" class="formField" /> -->
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span *ngFor="let pick of element.from; let i=index; let onlyFirst = first">
                      <strong style="color: #0B7D2E;">P{{i+1}}</strong> - {{pick.loc_id.name}} {{pick.loc_id.city}}<br>
                      <div *ngIf="onlyFirst" style="font-size: 10px; color: #757575;">{{'OPEN_BID.date' | translate}} : {{element.pickDate}}</div>
                      <span *ngIf="(element.length > 1) && (i != element.length-1)">,</span>
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="to">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader" style="text-align: center;">
                    To
                    <!-- <input type="text" placeholder="To" title="To" (click)="$event.stopPropagation()" class="formField" /> -->
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span *ngFor="let delivery of element.to; let i=index">
                      <b style="color: #D8511F;">D{{i+1}}</b> -  {{delivery.loc_id.name}} - {{delivery.loc_id.city}}<br>
                    <span *ngIf="(element.length > 1) && (i != element.length-1)">,</span>
                  </span>
                  </td>
                </ng-container>


                <ng-container matColumnDef="vehicle">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
                    {{'OPEN_BID.vehType' | translate}}
                    <!-- <input type="text" placeholder="Vehicle" title="Vehicle" (click)="$event.stopPropagation()" class="formField" /> -->
                  </th>
                  <td mat-cell *matCellDef="let element"> 
                    <div *ngIf="element.vehicle.name">
                      {{element.vehicle.name}}
                    </div>
                    <div *ngIf="!element.vehicle.name">
                      {{element.vehicle}}
                    </div>  
                  </td>
                </ng-container>
                
                <ng-container matColumnDef="req_no_of_vehicles">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
                    {{'OPEN_BID.requested' | translate}}
                    </th>
                  <td mat-cell *matCellDef="let element"> 
                    <div class="vehicles" *ngIf="!element.weight_based">
                      <div>
                        {{'BIDORDER.no_of_vehicles' | translate}}: {{element.req_no_of_vehicles}} 
                      </div>
                      <div *ngIf="element.cancelled_vehicles" style="color: red;">
                        {{'BIDORDER.cancelled' | translate}}: {{element.cancelled_vehicles}} 
                      </div>
                      
                    </div>
                    <div class="weight" *ngIf="element.weight_based">
                      <span>{{'BIDORDER.weight_requested' | translate}}: {{element.shipmentWeight}} {{element.uom | titlecase}}</span>

                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="deadline">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
                    {{'OPEN_BID.bidEndTime' | translate}}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div *ngIf="element.is_bidding">
                      {{element.deadline}}<br>
                      <!-- <span class="fromNow">
                        {{element.readableDeadline}}
                      </span> -->
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="costPerVehicle">
                  <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'OPEN_BID.startingBidAmount' | translate}} ({{currencySymbol}}) </th>
                  <td mat-cell *matCellDef="let element">
                    <!-- {{element.costPerVehicle |numberFormat:element.costPerVehicle}}
                    <span *ngIf="element.weight_based">/ {{element.uom | titlecase}}</span> -->
                    <ng-container *ngIf="element.bid_flow !== 'rfq'">
                      {{element.costPerVehicle |numberFormat:element.costPerVehicle}}
                      <span *ngIf="element.weight_based">/ {{element.uom | titlecase}}</span>
                    </ng-container>
                    <ng-container *ngIf="element.bid_flow === 'rfq'">
                      -
                    </ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'OPEN_BID.actions' | translate}} </th>
                  <td mat-cell *matCellDef="let element">
                    <div class="buttons">
                      <div class="button" style = "background-color: #3c7715" (click) = "$event.stopPropagation();openBidAcceptDialog(element)" >{{'OPEN_BID.startBid' | translate}}</div>
                    </div>
                  </td>
                </ng-container>

                <!-- Header row second group -->

                <!-- <ng-container matColumnDef="span-order">
                  <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="1">  </th>
                </ng-container>

                <ng-container matColumnDef="span-shipper">
                  <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="1">  </th>
                </ng-container>

                <ng-container matColumnDef="span-from">
                  <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="1">  </th>
                </ng-container>

                <ng-container matColumnDef="span-to">
                  <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="1">  </th>
                </ng-container>

                <ng-container matColumnDef="span-vehicleType">
                  <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="1"> </th>
                </ng-container>

                <ng-container matColumnDef="span-vehicle">
                  <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="2"> Vehicle </th>
                </ng-container>

                <ng-container matColumnDef="span-costPerVehicle">
                  <th mat-header-cell *matHeaderCellDef [attr.colspan]="1" class="border customHeader"></th>
                </ng-container>

                <ng-container matColumnDef="span-status">
                  <th mat-header-cell *matHeaderCellDef [attr.colspan]="2" class="border customHeader"></th>
                </ng-container>

                <tr mat-header-row
                  *matHeaderRowDef="['span-order', 'span-shipper', 'span-from', 'span-to', 'span-vehicleType', 'span-vehicle', 'span-costPerVehicle', 'span-status']">
                </tr> -->

                <tr mat-header-row *matHeaderRowDef="ordersDisplay; sticky: true;" style="font-weight: bold !important;"></tr>
                <tr mat-row (click)="openOrderDetails(row);" [ngClass]="{highlightRow: (selectedOrderData)?row._id == selectedOrderData._id:false}" *matRowDef="let row; columns: ordersDisplay;" style="height: 65px; font-weight: bold;"></tr>
              </table>
            </ng-container>

              <mat-paginator [length]="(ordersList)? totalOrders:0" [showFirstLastButtons]="true" [pageSize]="25" style="border-top: solid 1px #ededed; border-bottom: solid 1px #ededed;"
                [pageSizeOptions]="[5, 10, 25, 50, 100]" (page)="pageNavigate($event)"></mat-paginator>
            </div>
            <div *ngIf="showLoader" class="loader">
              <div class="load">
                <mat-spinner></mat-spinner>
              </div>
            </div>

            <ng-template #noOrders>
              <div class="noOrders" style="padding: 30px; text-align: center;">
                {{'OPEN_BID.noOrder' | translate}}
              </div>
            </ng-template>
          </div>

      </div>
      </div>

